module.exports = __WEBPACK_EXTERNAL_MODULE_6__;


//////////////////
// WEBPACK FOOTER
// external "@ngforage/ngforage-ng5"
// module id = 6
// module chunks = 0 1